import { useQuery } from '@tanstack/react-query';
import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';

import * as api from 'apis/merchant-admin-server/api';

import DeveloperPreview from './DeveloperPreview';
import { COOKIE } from './constants';
import * as cookie from './cookie';
import dispatchActivePreviewChangeEvent from './dispatchActivePreviewChangeEvent';

const Preview = styled(DeveloperPreview)``;

const Root = styled.div`
  margin: 16px auto;
  width: calc(100% - 64px);
  max-width: 960px;

  ${Preview} + ${Preview} {
    margin-block-start: 8px;
  }
`;

const DeveloperPreviews = () => {
  const { data = [] } = useQuery(['developer-previews'], api.fetchDeveloperPreviews);

  const previews = useMemo(() => data.slice().sort((a, b) => b.number - a.number), [data]);

  const [activePreviewNumber, setActivePreviewNumber] = useState<number | undefined>(() => {
    const string = cookie.get(COOKIE);
    return string ? parseInt(string, 10) : undefined;
  });

  useEffect(() => {
    if (activePreviewNumber) {
      dispatchActivePreviewChangeEvent(activePreviewNumber);
    }
  }, [activePreviewNumber]);

  return (
    <Root>
      {previews.map(preview => (
        <Preview
          checked={activePreviewNumber === preview.number}
          onChange={setActivePreviewNumber}
          preview={preview}
          key={preview.number}
        />
      ))}
    </Root>
  );
};

export default DeveloperPreviews;
